var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { attrs: { id: "embed-overview-map" } }),
    _vm._v(" "),
    _vm.showLoadingOverlay
      ? _c("div", { staticClass: "main-map-overlay" }, [
          _c("div", [
            _c("h4", [_vm._v(_vm._s(_vm.loadingOverlayText))]),
            _vm._v(" "),
            _vm._m(0),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "embeddable-map-legend" },
      [
        _c(
          "h4",
          [
            _vm._v("Legend "),
            _c("font-awesome-icon", {
              attrs: { icon: _vm.legendIcon },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  _vm.legendVisible = !_vm.legendVisible
                },
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _vm.legendVisible
          ? _c(
              "transition-group",
              { staticStyle: { "margin-top": "5px" }, attrs: { name: "list" } },
              _vm._l(_vm.mapLayers, function (layer, ref) {
                return _c(
                  "div",
                  { key: layer.name, staticClass: "embeddable-legend-item" },
                  [
                    _c("img", {
                      attrs: { src: _vm.LegendGraphic(ref), alt: "" },
                    }),
                    _vm._v(" "),
                    _c("div", [_vm._v(_vm._s(layer.name))]),
                    _vm._v(" "),
                    _c("div", { staticClass: "clearfix" }),
                  ]
                )
              }),
              0
            )
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "overlay-spinner" }, [
      _c("div", { staticClass: "s-r1" }),
      _c("div", { staticClass: "s-r2" }),
      _c("div", { staticClass: "s-r3" }),
      _c("div", { staticClass: "s-r4" }),
      _c("div", { staticClass: "s-r5" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }